import type { ConfigContainerRole } from '../types/ConfigAPI';
import { devLog } from './devLog';

/**
 * `group` and `region` are only meaningful to assistive tech with an accessible
 * name, but `ConfigContainerRole` doesn't require one at the type level (a
 * discriminated union would break consumers extending config props) — warn in
 * dev instead.
 */
export function warnUnnamedContainerRole(
  componentName: string,
  role: ConfigContainerRole['role'],
  ariaLabel: string | undefined,
  ariaLabelledby: string | undefined
): void {
  if (
    (role === 'group' || role === 'region') &&
    ariaLabel == null &&
    ariaLabelledby == null
  ) {
    devLog(
      `${componentName}: role="${role}" requires an accessible name. Provide \`ariaLabel\` or \`ariaLabelledby\` so screen readers can announce it.`
    );
  }
}
